import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import Loading from "../../UI/Loading";

/** Quantidade de aulas planejadas por bimestre da turma - disciplina. */
const CronogramaQuantAulaBimestreTable = ({ list, isLoading, onEdit, onDelete }) => {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando quantidades de aulas..." />
      </Box>
    );
  }

  if (list.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <EventNoteOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhuma quantidade de aulas cadastrada. Use "Gerar quantidades" ou "Novo Registro".
        </Typography>
      </Box>
    );
  }

  const total = list.reduce((soma, item) => soma + (Number(item.quantAulas) || 0), 0);

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Quantidade de aulas por bimestre">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Bimestre</TableCell>
            <TableCell align="right">Quantidade de aulas</TableCell>
            <TableCell align="right" sx={{ width: 96 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((item) => (
            <TableRow key={item.codigo} hover>
              <TableCell>
                {item.bimestre?.numeroBimestre}º Bimestre
                <Typography variant="caption" color="text.secondary" component="span" ml={1}>
                  {item.bimestre?.anoLetivo}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" fontWeight={600}>
                  {item.quantAulas}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Tooltip title="Editar">
                  <IconButton size="small" onClick={() => onEdit(item)}>
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Remover">
                  <IconButton size="small" onClick={() => onDelete(item)}>
                    <DeleteOutlineIcon fontSize="small" color="error" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
          <TableRow sx={{ "& td": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Total no ano</TableCell>
            <TableCell align="right">{total}</TableCell>
            <TableCell />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CronogramaQuantAulaBimestreTable;
